var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf2pog-page"},[_c('iframe',{staticClass:"pdf2pog-frame",attrs:{"src":"https://pdf2pogtabular-csgmcjbedhb0dmcu.uksouth-01.azurewebsites.net/","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }